import { Question } from '@neo.tax/shared';

export class BadAnswerTypeForInputTypeError extends Error {
  constructor({ answerType, inputType, questionCode }: Question) {
    super(`Unexpected AnswerType ${answerType} for ${inputType} field ${questionCode}.`);
  }
}

export class MissingAvailableChoices extends Error {
  constructor({ questionCode }: Question) {
    super(`Question ${questionCode} should have availableChoices, but they were not given.`);
  }
}
